import './index.scss';
import { NavLink } from 'react-router-dom';
import { getFirstName } from '@utils';
import { useSelector } from 'react-redux';
import { currentUserRoleSelector, currentUserSelector } from '@selectors/user';
import { defaultDashboardRouteSelector } from '@selectors/app';

export const NavigationDashboard = () => {
  const currentUser = useSelector(currentUserSelector);
  const currentUserRole = useSelector(currentUserRoleSelector);
  const defaultDashboardRoute = useSelector(defaultDashboardRouteSelector);

  return (
    <div className="username-box">
      <span className="username">{getFirstName(currentUser)}</span>
      {defaultDashboardRoute ? (
        <NavLink
          data-testid="role-label"
          className={({ isActive }) => `role-link${isActive ? ' active' : ''}`}
          to={defaultDashboardRoute}
        >
          {currentUserRole?.name}
        </NavLink>
      ) : (
        <span data-testid="role-label" className="role-link">
          {currentUserRole?.name}
        </span>
      )}
    </div>
  );
};
